// Manual Email System
export const generateContactEmail = (formData) => {
  const emailTemplate = `
Subject: ${formData.subject} - RiseWithilly Contact Form

Hello,

The following information has been sent from the RiseWithilly website:

CONTACT INFORMATION:
─────────────────────────────
Full Name: ${formData.name}
Email: ${formData.email}
Subject: ${formData.subject}
Date: ${new Date().toLocaleString('en-US')}

MESSAGE:
─────────────────────────────
${formData.message}

─────────────────────────────
This message was automatically generated from the RiseWithilly website contact form.
Reply to: ${formData.email}
`;

  return emailTemplate;
};

export const generatePurchaseEmail = (course, formData) => {
  const emailTemplate = `
Subject: Course Purchase Request - ${course.title}

Hello,

The following course purchase request has been sent from the RiseWithilly website:

PURCHASE INFORMATION:
─────────────────────────────
Course: ${course.title}
Price: $${course.price}
Duration: ${course.duration}
Level: ${course.level}
Instructor: ${course.instructor}

CUSTOMER INFORMATION:
─────────────────────────────
Full Name: ${formData.firstName} ${formData.lastName}
Email: ${formData.email}
Date: ${new Date().toLocaleString('en-US')}

COURSE DESCRIPTION:
─────────────────────────────
${course.description}

COURSE CONTENT:
─────────────────────────────
${course.modules.map((module, index) => `${index + 1}. ${module}`).join('\n')}

COURSE FEATURES:
─────────────────────────────
${course.features.map(feature => `• ${feature}`).join('\n')}

─────────────────────────────
This request was automatically generated from the RiseWithilly website purchase form.
Contact customer at: ${formData.email}
`;

  return emailTemplate;
};

export const copyToClipboard = async (text) => {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch (err) {
    // Fallback for older browsers
    const textArea = document.createElement('textarea');
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.select();
    try {
      document.execCommand('copy');
      document.body.removeChild(textArea);
      return true;
    } catch (err) {
      document.body.removeChild(textArea);
      return false;
    }
  }
};

export const getEmailAddress = () => {
  return 'karabacakhilal1.1@gmail.com'; // Enter your email address here
};
